import { MaskLine } from "@/components/motion";
import { Eyebrow } from "@/components/kit";

// Encabezado editorial para páginas internas
export const PageHeader = ({ eyebrow, eyebrowColor = "#B94742", title, subtitle }) => (
  <section className="bg-cream px-5 sm:px-8 lg:px-12 pt-16 sm:pt-24 pb-10">
    <div className="mx-auto max-w-7xl">
      <Eyebrow color={eyebrowColor}>{eyebrow}</Eyebrow>
      <h1 className="mt-5 font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-[0.95] tracking-tighter text-ink">
        {title.map((line, i) => (
          <MaskLine key={i} delay={0.1 + i * 0.12}>
            {line}
          </MaskLine>
        ))}
      </h1>
      {subtitle && (
        <p className="mt-6 max-w-2xl text-lg text-ink/70 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);
